import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
var TermsOfUse = function TermsOfUse() {
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            pb: '56px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        sx: {
            color: '#212121',
            textAlign: 'left',
            m: 3
        }
    }, "Terms of Use"), /*#__PURE__*/ React.createElement(Paper, {
        elevation: 1,
        sx: {
            p: 3,
            mx: 3,
            backgroundColor: '#ffffff'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "1. Acceptance of Terms"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "By accessing or using this Deloitte commercial software-as-a-service (SaaS) application (\"Service\"), you agree to be bound by these Terms of Use (\"Terms\"). If you do not agree to these Terms, you may not access or use the Service.")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "2. Description of Service"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "This Service is a commercial SaaS application provided by Deloitte Development LLC (\"Deloitte,\" \"we,\" \"us,\" or \"our\"). The Service provides role-based access control (RBAC) functionality and related features designed for enterprise use.")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "3. User Accounts and Access"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "Access to the Service is provided through user accounts managed by your organization. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "4. Permitted Use"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "You may use the Service solely for your organization's internal business purposes in accordance with these Terms and any applicable service agreement between your organization and Deloitte. You may not:"), /*#__PURE__*/ React.createElement(Typography, {
        component: "ul",
        sx: {
            ml: 2
        }
    }, /*#__PURE__*/ React.createElement("li", null, "Use the Service for any unlawful purpose or in violation of any applicable laws"), /*#__PURE__*/ React.createElement("li", null, "Attempt to gain unauthorized access to the Service or its related systems"), /*#__PURE__*/ React.createElement("li", null, "Interfere with or disrupt the Service or servers or networks connected to the Service"), /*#__PURE__*/ React.createElement("li", null, "Reverse engineer, decompile, or disassemble any part of the Service"), /*#__PURE__*/ React.createElement("li", null, "Use the Service to transmit any harmful, threatening, or inappropriate content"))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "5. Data and Privacy"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "Your use of the Service is also governed by our Privacy Notice, which is incorporated into these Terms by reference. We collect, use, and protect your information in accordance with our Privacy Notice and applicable privacy laws.")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "6. Intellectual Property"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "The Service and all related content, features, and functionality are owned by Deloitte and are protected by copyright, trademark, and other intellectual property laws. You may not reproduce, modify, distribute, or create derivative works based on the Service without our express written permission.")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "7. Service Availability"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "We strive to maintain the availability of the Service, but we do not guarantee uninterrupted access. We may temporarily suspend or restrict access to the Service for maintenance, updates, or other operational reasons.")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "8. Disclaimers and Limitation of Liability"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "THE SERVICE IS PROVIDED \"AS IS\" AND \"AS AVAILABLE\" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. TO THE FULLEST EXTENT PERMITTED BY LAW, DELOITTE DISCLAIMS ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT."), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "IN NO EVENT SHALL DELOITTE BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATING TO YOUR USE OF THE SERVICE.")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "9. Indemnification"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "You agree to indemnify, defend, and hold harmless Deloitte from and against any claims, damages, losses, or expenses arising out of your use of the Service or violation of these Terms.")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "10. Termination"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "We may suspend or terminate your access to the Service at any time, with or without cause, and with or without notice. Upon termination, your right to use the Service will immediately cease.")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "11. Changes to Terms"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "We reserve the right to modify these Terms at any time. Changes will be effective upon posting of the revised Terms. Your continued use of the Service after any changes constitutes acceptance of the modified Terms.")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "12. Governing Law"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "These Terms are governed by and construed in accordance with the laws of the State of Delaware, without regard to its conflict of laws principles.")), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, "13. Contact Information"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, "If you have any questions about these Terms, please contact us through your designated Deloitte representative or through the support channels provided within the Service."))));
};
export default TermsOfUse;
